<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header style="padding:2rem 1rem 0rem 1rem;">
      <div>已选物资：{{form.piece}}</div>
    </zj-layout-header>
    <zj-layout-main style="padding:1rem 1rem;">
      <zj-layout-container>
        <zj-layout-main style="padding:0px 0px;">
          <el-table :data="gridData" height="100%" max-height="27rem" style="min-height:27rem;">
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column property="MaterialName" label="物资名称"></el-table-column>
            <el-table-column property="MaterialTypeId" label="物资类型" :formatter="ConvertMaterialType" align="center"></el-table-column>
            <el-table-column property="StockNum" label="现库存" align="center"></el-table-column>
          </el-table>
        </zj-layout-main>
        <zj-layout-footer style="padding:1rem 0px;">
          <el-divider></el-divider>
          <el-form :model="form" class="zj-search-form" label-width="8rem" style="margin-top:4rem;">
            <el-form-item label="入库数量" style="display:inline-block;">
              <el-input-number style="width:50rem;" v-model="form.num" autocomplete="off" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item label="入库日期" style="display:inline-block;">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="form.InDate"
                style="width:50rem;"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </zj-layout-footer>
      </zj-layout-container>
    </zj-layout-main>
    <zj-layout-footer style="text-align:center;">
      <el-button @click="onBack()">取消</el-button>
      <el-button @click="submitForm()">确定</el-button>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import MyApis from "../../../apis";
export default {
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      gridData: [],
      form: {
        piece: "（共0条）",
        num:1,
        InDate: new Date()
      }
    };
  },
  props: {
    viewData: Object,
    materialTypedate:Object
  },
  mounted: function() {
    var selectData = this.viewData;
    this.form.piece = "（共"+selectData.length+"条）";
    this.gridData = selectData;
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    //取消按钮
    onBack() {
      //this.dialogTableVisible = false;
      this.$emit("cancel", {});
    },
    //确定按钮
    submitForm() {
      const datalist = this.viewData;
      datalist.forEach(item => {
        item.IsInOut = true;
        item.InOutNum = parseInt(this.form.num);
        item.PickupDate = this.form.InDate;
      });
      this.loading = true;
      this.loadingText = '保存中...';
      new MyApis.MaterialsApi()
        .InOutStock(datalist)
        .then(r => {
          r = r.data.Data;
          if (r) {
            this.$message({
              type: "success",
              message: "入库成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: "入库失败!"
            });
          }
          this.logInfo.ActionName = "应急物资入库";
          this.logInfo.LogMessage = r ? "应急物资入库成功" : "应急物资入库失败";
          this.logInfo.ModuleName = "应急系统";
          this.logInfo.PageName = "应急物资管理";
          this.addOperationLog();
          this.$emit("search", {});
          this.$emit("ok", {});
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });

      //this.dialogTableVisible = false;
    },
    ConvertMaterialType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr=this.materialTypedate[data];
      return   levelstr ;
    },
  }
};
</script>
<style lang="scss" scoped>
.zj-layout-container .zj-layout-main .zj-table-container {
    margin-top: 0.8rem;
    margin-bottom: 1rem;
    flex: 1 1 auto;
    overflow: auto;
    overflow-x:hidden;
    max-height: 30rem;
  }
</style>